import { inresiCmsAppUrl } from "./http";

/**
 * Convert a configured URL (which may include a path or trailing slash) into
 * its canonical origin form (`scheme://host[:port]`), to match how browsers
 * serialise `MessageEvent.origin`.
 */
function toOrigin(url: string): string | null {
  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
}

/**
 * Allow-list of origins that may send theme messages to the embed
 * (currently just the CMS app). Built once at module load.
 */
const ALLOWED_ORIGINS = new Set<string>(
  [inresiCmsAppUrl]
    .filter((v): v is string => typeof v === "string" && v.length > 0)
    .map(toOrigin)
    .filter((v): v is string => v !== null)
);

// Warn in production if the CMS origin allow-list is empty
if (ALLOWED_ORIGINS.size === 0 && import.meta.env.PROD) {
  // eslint-disable-next-line no-console
  console.warn(
    "[cmsOrigin] VITE_INRESI_CMS_APP_URL is not set. " +
      "Theme preview messages will be rejected."
  );
}

export function isAllowedCmsOrigin(origin: string): boolean {
  if (ALLOWED_ORIGINS.size === 0) {
    // Local development convenience
    if (import.meta.env.DEV) {
      return true;
    }

    // Production should fail closed
    return false;
  }

  return ALLOWED_ORIGINS.has(origin);
}
